// src/components/EmailBuilderEmbed.js
import React from "react";

export default function EmailBuilderEmbed({ docId, token }) {
  const base = "https://email-builder-test-theta.vercel.app/";
  const src = `${base}?${new URLSearchParams({
    ...(docId ? { docId } : {}),
    ...(token ? { token } : {}),
  }).toString()}`;

  return (
    <iframe
      title="Email Builder"
      src={src}
      style={{ width: "100%", height: "100vh", border: 0 }}
      allow="clipboard-read; clipboard-write"
    />
  );
}
